import { Card, CardContent, Box, Grid, useTheme } from "@mui/material";
import CardTitle from "../components/CardTitle";
import { tokens } from "../theme/tokens";

const DashboardCard = ({
  cardTitle,
  children,
  height = "300px",
  xs = 12,
  md = 6,
  sx = {},
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Grid item xs={xs} md={md}>
      <Card
        elevation={0}
        sx={{
          bgcolor: colors.surface.card,
          border: `1px solid ${colors.surface.border}`,
          borderRadius: theme.shape.radius?.lg || 2,
          display: "flex",
          flexDirection: "column",
          height,
          overflow: "hidden",
          transition: "border-color 180ms ease, transform 180ms ease, box-shadow 180ms ease",
          boxShadow: "0 18px 40px rgba(0,0,0,0.18)",
          "&:hover": {
            borderColor: colors.scalpelTeal[500],
            transform: "translateY(-2px)",
            boxShadow: "0 22px 50px rgba(0,0,0,0.24)",
          },
          ...sx,
        }}
      >
        <CardContent
          sx={{
            flexGrow: 1,
            height: "100%",
            boxSizing: "border-box",
            p: 2,
          }}
        >
          {cardTitle && <CardTitle>{cardTitle}</CardTitle>}

          <Box sx={{ height: "100%" }}>{children}</Box>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default DashboardCard;